import {
  createApp
} from 'vue'
import App from './App.vue'
import './assets/index.css'
import router from './router'
import 'aos/dist/aos.css'
/* eslint-disable no-undef */
window.global = window;
window.process = {
  env: {
    NODE_ENV: 'development'
  }
};

createApp(App).use(router).mount('#app')
